// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#home > *[data-v-3dd2e005] {\n  margin-bottom: 40px !important;\n}\n#home > *[data-v-3dd2e005]:last-child {\n  margin-bottom: 0 !important;\n}\n.el-skeleton[data-v-3dd2e005] {\n  margin: 50px 0px;\n}\n", ""]);
// Exports
module.exports = exports;
